export type FormMessages = {
	text: { empty: string; error: string };
	textarea: { empty: string; error: string };
	select: { empty: string };
	complete: { empty: string; entry: string; error: string };
	file: { empty: string; size: string; accept: string };
	code: { empty: string; error: string };
	mask: { empty: string; error: string };
	email: { empty: string; error: string };
	tel: { empty: string; error: string };
	date: { empty: string; error: string };
	password: { empty: string; error: string };
	passwordAuth: { empty: string; error: string };
	conform: { empty: string; error: string };
	city: { empty: string; entry: string; error: string };
	address: { empty: string; entry: string; error: string };
};

export const messagesRu: FormMessages = {
	text: {
		empty: 'Поле обязательно к заполнению.',
		error: 'Поле должно содержать не менее 2 символов.',
	},
	textarea: {
		empty: 'Поле обязательно к заполнению.',
		error: 'Поле должно содержать не менее 2 и не более 150 символов.',
	},
	select: {
		empty: 'Выберите значение поля.',
	},
	complete: {
		empty: 'Поле обязательно к заполнению.',
		entry: 'Выберите значение поля.',
		error: 'Проверьте, правильно ли заполнено поле.',
	},
	file: {
		empty: 'Выберите файл.',
		size: 'Превышен допустимый размер.',
		accept: 'Неверный формат файла.',
	},
	code: {
		empty: 'Введите код из SMS.',
		error: 'Проверьте, правильно ли введен код.',
	},
	mask: {
		empty: 'Поле обязательно к заполнению.',
		error: 'Проверьте, правильно ли заполнено поле.',
	},
	email: {
		empty: 'Поле обязательно к заполнению.',
		error: 'Проверьте, правильно ли указан email.',
	},
	tel: {
		empty: 'Поле обязательно к заполнению.',
		error: 'Проверьте, правильно ли указан телефон.',
	},
	date: {
		empty: 'Поле обязательно к заполнению.',
		error: 'Проверьте, правильно ли указана дата.',
	},
	password: {
		empty: 'Поле обязательно к заполнению.',
		error: 'Должен содержать не менее 6 символов.',
	},
	passwordAuth: {
		empty: 'Поле обязательно к заполнению.',
		error: 'Должен содержать не менее 6 символов.',
	},
	conform: {
		empty: 'Поле обязательно к заполнению.',
		error: 'Значения полей не совпадают.',
	},
	city: {
		empty: 'Поле обязательно к заполнению.',
		entry: 'Выберите название города.',
		error: 'Выберите название города.',
	},
	address: {
		empty: 'Поле обязательно к заполнению.',
		entry: 'Введите корректный адрес.',
		error: 'Введите полный адрес, c указанием номера дома.',
	},
};

export const messagesEn: FormMessages = {
	text: {
		empty: 'This field is required.',
		error: 'The field must contain at least 2 characters.',
	},
	textarea: {
		empty: 'This field is required.',
		error: 'The field must be between 2 and 150 characters.',
	},
	select: {
		empty: 'Please select a value.',
	},
	complete: {
		empty: 'This field is required.',
		entry: 'Please select a value.',
		error: 'Please check that the field is filled in correctly.',
	},
	file: {
		empty: 'Please choose a file.',
		size: 'The file exceeds the maximum allowed size.',
		accept: 'Invalid file format.',
	},
	code: {
		empty: 'Enter the code from the SMS.',
		error: 'Please check that the code is entered correctly.',
	},
	mask: {
		empty: 'This field is required.',
		error: 'Please check that the field is filled in correctly.',
	},
	email: {
		empty: 'This field is required.',
		error: 'Please check that the email address is correct.',
	},
	tel: {
		empty: 'This field is required.',
		error: 'Please check that the phone number is correct.',
	},
	date: {
		empty: 'This field is required.',
		error: 'Please check that the date is correct.',
	},
	password: {
		empty: 'This field is required.',
		error: 'Must be at least 6 characters long.',
	},
	passwordAuth: {
		empty: 'This field is required.',
		error: 'Must be at least 6 characters long.',
	},
	conform: {
		empty: 'This field is required.',
		error: 'The values do not match.',
	},
	city: {
		empty: 'This field is required.',
		entry: 'Please select a city.',
		error: 'Please select a city.',
	},
	address: {
		empty: 'This field is required.',
		entry: 'Please enter a valid address.',
		error: 'Please enter the full address, including the building number.',
	},
};

/**
 * Локаль сообщений: `data-form-locale` на предке поля / формы, иначе класс `en-version` на `body`.
 */
export function getFormMessages(context?: HTMLElement | null): FormMessages {
	const localeRoot = context?.closest?.('[data-form-locale]');
	const attr = localeRoot?.getAttribute('data-form-locale')?.trim().toLowerCase();
	if (attr === 'en') return messagesEn;
	if (attr === 'ru') return messagesRu;

	if (document.body?.classList.contains('en-version')) {
		return messagesEn;
	}

	return messagesRu;
}

export const messages: FormMessages = messagesRu;
